export default __webpack_public_path__ + "3be1ba521aa6e9084ac840958b700751.svg";